import React, { useState, useEffect } from 'react';
import {
  Box,
  Heading,
  Textarea,
  Button,
  useToast,
  VStack,
  Flex
} from '@chakra-ui/react';
import { callApi } from '../../callApi';

const VarianceNotesSection = ({ caseId, initialNotes, accessToken }) => {
  const [notes, setNotes] = useState(initialNotes || '');
  const [isSaving, setIsSaving] = useState(false);
  const toast = useToast();

  useEffect(() => {
    setNotes(initialNotes || '');
  }, [initialNotes]);

  const handleSave = async () => {
    setIsSaving(true);
    try {
      const response = await callApi(`/api/mph/coding-variance/${caseId}/feedback`, accessToken, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ notes })
      });

      if (response.ok) {
        toast({
          title: 'Notes saved.',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      } else {
        throw new Error('Failed to save notes');
      }
    } catch (error) {
      console.error('Error saving notes:', error);
      toast({
        title: 'Error saving notes.',
        description: error.message,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Box bg="white" p={4} borderRadius="md" shadow="sm" borderWidth="1px" mb={6}>
      <Heading size="sm" mb={2} color="gray.700">Reviewer Notes</Heading>
      <Flex gap={4} align="flex-start">
        <Textarea
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="Add notes about this variance..."
          size="sm"
          minHeight="80px"
          flex="1"
        />
        <Button 
          colorScheme="blue" 
          size="sm" 
          onClick={handleSave} 
          isLoading={isSaving}
          px={6}
        >
          Save
        </Button>
      </Flex>
    </Box>
  );
};

export default VarianceNotesSection;
